import { Author, List, Collection, CollectionKind } from '@/models'

const createCollectionGetter = (kind, filters) => state => {
  let arr = state.libraryData.collections.filter(c => c.get('kindId') == kind)

  filters && filters.forEach((filter) => {
    arr = arr.filter(filter)
  })

  return arr.sort((a, b) => a.get('order') - b.get('order'))
}

export const libraryData = {
  state: {
    libraryData: {
      authors: [],
      collections: [],
      collectionKinds: [],
      bookCollections: [], // 课本,
      lists: [], // 诗单
    },
  },
  mutations: {
    setLibraryData(state, data) {
      Object.keys(data).forEach((key) => {
        state.libraryData[key] = data[key]
      })
    }
  },
  actions: {
    loadLibraryData({ commit }) {
      Promise.all([
        Author.getHotAuthors(),
        Collection.getCollections(),
        List.getSelected(1, 6),
        CollectionKind.getAll()
      ]).then(([authors, collections, lists, collectionKinds]) => {
        commit('setLibraryData', {
          authors,
          collections,
          lists,
          collectionKinds
        })
      })
    }
  },
  getters: {
    libraryData: state => state.libraryData,

    collectionKinds: state => state.libraryData.collectionKinds,

    collections: state => state.libraryData.collections,

    collectionsByKindId: (state) => {
      return (id) => {
        let arr = state.libraryData.collections.filter(c => c.get('kindId') == id)
        return arr.sort((a, b) => a.get('order') - b.get('order'))
      }
    },

    sortAuthors: (state) => {
      let result = state.libraryData.authors.sort((a, b) => a.get('name').length > b.get('name').length)
      // let result = state.libraryData.authors

      return result
    },

    quotationCollections: createCollectionGetter(9), // 用典
    classicCollections: createCollectionGetter(1), // 选集
    topicCollections: createCollectionGetter(2), // 主题
    tuneCollections: createCollectionGetter(7), // 词牌
    natureCollections: createCollectionGetter(3), // 写景
    festivalCollections: createCollectionGetter(4), // 节日
    termCollections: createCollectionGetter(5), // 节气
    seasonCollections: createCollectionGetter(8), // 时令
    bookCollections: createCollectionGetter(6, [(c) => {
      let name = c.get('name')
      return name !== '声律启蒙' && name !== '千家诗' && name !== '幼学琼林'
    }]), // 课本
    geographyCollections: createCollectionGetter(10), // 地理
    mountainCollections: createCollectionGetter(26),  // 名山
    cityCollections: createCollectionGetter(27),  // 城市
    timeCollections: createCollectionGetter(25),  // 时间
    flowerCollections: createCollectionGetter(20),  // 花卉

    // 小学课本
    elementaryBookClcts: (state) => {
      let collections = createCollectionGetter(6, [(c) => {
        return c.get('name').indexOf('小学') > -1
      }])(state)

      // 将最前面两本课本移动到最后
      collections.splice(0, 2).forEach(removeItem => {
        collections.push(removeItem)
      })

      return collections
    },

    // 初中课本
    juniorBookClcts: (state) => {
      let collections = createCollectionGetter(6, [(c) => {
        return c.get('name').indexOf('初') > -1
      }])(state)

      // 将最前面两本课本移动到最后
      collections.splice(0, 2).forEach(removeItem => {
        collections.push(removeItem)
      })

      return collections
    },

    // 高中课本
    HighBookClcts: (state) => {
      let collections = createCollectionGetter(6, [(c) => {
        return c.get('name').indexOf('高') > -1
      }])(state)

      // 将最前面两本课本移动到最后
      collections.splice(0, 2).forEach(removeItem => {
        collections.push(removeItem)
      })

      return collections
    },

    // keben.xcz.im使用的选集
    bookClassicCollections: createCollectionGetter(1, [(c) => {
      let filterArr = ["维摩诘所说经", "大乘佛教经典", "金刚经", "地藏经", "妙法莲华经", "四十二章经", "圆觉经", "六祖坛经", "周易", "三十六计", "鬼谷子", "孙子兵法", "幼学琼林"]
      let index = filterArr.findIndex(item => item === c.get('name'))

      return index === -1
    }])
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/library-data/index.js